/** @typedef {{ slug: string, name: string }} AchievementArtEntry */

/** @type {Record<number, AchievementArtEntry>} */
export const ACHIEVEMENT_ART = {
  1: { slug: "pm-streak-3", name: "WEN Streak 3" },
  2: { slug: "pm-wins-10", name: "10 wins" },
  3: { slug: "pm-volume-buy", name: "Volume buyer" },
  4: { slug: "pm-first-trade", name: "First trade" },
  5: { slug: "pm-early-win", name: "Early win" },
  6: { slug: "pm-cat-streak-3", name: "Category streak 3" },
  7: { slug: "pm-created-n", name: "Markets created" },
  8: { slug: "pm-onboard-verified", name: "Verified trader" },
};

/**
 * @param {number} type
 * @param {string} [origin]
 * @returns {string}
 */
export function achievementImageUrl(type, origin = globalThis.window?.location?.origin ?? "") {
  const entry = ACHIEVEMENT_ART[type];
  if (!entry) {
    throw new Error(`Unknown achievement type: ${type}`);
  }
  return `${origin}/nft/${entry.slug}.svg`;
}

/**
 * @param {number} type
 * @param {string} origin
 * @returns {string}
 */
export function achievementMetadataUrl(type, origin) {
  return `${origin}/nft/${type}`;
}
